import { render } from "./Script.vue?vue&type=template&id=09ecbfb0&scoped=true&ts=true"
import script from "./Script.vue?vue&type=script&lang=ts"
export * from "./Script.vue?vue&type=script&lang=ts"

import "./Script.vue?vue&type=style&index=0&id=09ecbfb0&scoped=true&lang=css"
import "./Script.vue?vue&type=style&index=1&id=09ecbfb0&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ecbfb0"]])

export default __exports__